export const vimeoSetting = {
	id: 248652010,
  controls: false,
  autoplay: false,
  loop: false,
  byline: false,
  title: false,
  sidedock: false,
  portrait: false,
}

export const FILE_NOTES = 'notes.json';
export const FILE_CHAPTERS = 'chapters.json';

export const MIN_NOTES_OPACITY = 0.6; // in seconds
export const NOTE_FADE_IN_TIME = 2; // in seconds
export const NOTE_SLIDE_UP_TIME = 4; // in seconds
export const NOTE_FADE_OUT_TIME = 1; // in seconds
export const PLAYER_FINISHED_PADDING = 2; // in seconds

export const TEXT_PLAY = 'Play';
export const TEXT_LOADING = 'Loading';
export const TEXT_CONTINUE = 'Continue';
export const TEXT_REPLAY = 'Replay';

export const TIME_BUTTON_FADE_OUT = 2000; // in ms
